import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "login",
  class: "login"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "login__form--logo",
  src: "/img/ifc.jpg"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      class: "login__form",
      "label-position": "top",
      model: _ctx.credentials,
      onKeyup: _withKeys(_ctx.login, ["enter","native"])
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_el_form_item, {
          prop: "username",
          label: _ctx.trans('label.username')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.credentials.username,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.credentials.username) = $event)),
              autocomplete: "off",
              placeholder: _ctx.trans('label.username'),
              autofocus: ""
            }, {
              suffix: _withCtx(() => [
                _createVNode(_component_Icon, { icon: "ic:baseline-person" })
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          prop: "password",
          label: _ctx.trans('label.password')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.credentials.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.credentials.password) = $event)),
              type: "password",
              autocomplete: "off",
              placeholder: _ctx.trans('label.password')
            }, {
              suffix: _withCtx(() => [
                _createVNode(_component_Icon, { icon: "ic:baseline-lock" })
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.login
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.trans("label.login")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["model", "onKeyup"])
  ]))
}